import React, {
  memo
} from "react";
import {
  Card
} from "@constants/Themed";
import DataChart from "@components/dataTables/DataChart";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";
import { StyleSheet } from "react-native";

interface DataChartWidgetProps {
  data: number;
}

const DataChartWidget: React.FC<DataChartWidgetProps> = ({
  data
}) => {
  const theme = themeSelector();

  const chartData = {
    month: {
      labels: [
        "01-Jan",
        "01-Feb",
        "01-Mar",
        "01-Apr",
        "01-May",
        "01-Jun",
      ],
      data: [
        data,
        data * 1.2,
        data * 0.8,
        data * 1.5,
        data * 1.1,
        data * 1.3,
      ],
    },
  };

  return (
    <Card style={styles.card}>
      <DataChart
        chartTitle="Data Analytics"
        state="month"
        reportData={chartData}
      />
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    borderRadius: 15,
    overflow: "hidden",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});

export default memo(DataChartWidget);
